import * as types from './types';
import * as api from './api';

export const assignProject = (projectId, engagementId) => (
  dispatch,
  getState
) => {
  const { shift } = getState();
  const project = shift.project[projectId];
  const engagement = shift.projects.engagementList.find(
    each => each.engagementId === engagementId
  );

  dispatch({ type: types.EDIT_PROJECT_REQUEST });
  return api
    .assignProject(project, engagement)
    .then(payload =>
      dispatch({
        type: types.EDIT_PROJECT_SUCCESS,
        payload,
        meta: {
          projectId,
          engagementId,
          project,
          engagement
        }
      })
    )
    .catch(payload =>
      dispatch({
        type: types.EDIT_PROJECT_ERROR,
        payload,
        meta: {
          projectId,
          engagementId,
          project,
          engagement
        }
      })
    );
};



// WEBPACK FOOTER //
// ./src/state/projects/operations.js